/* Reviews wall — search, topic chips, sort. Purely client side. */
(function () {
  'use strict';
  document.querySelectorAll('[data-rw]').forEach(function (root) {
    var list = root.querySelector('[data-rw-list]');
    if (!list) return;
    var cards = Array.prototype.slice.call(list.children);
    var search = root.querySelector('[data-rw-search]');
    var sort = root.querySelector('[data-rw-sort]');
    var chips = root.querySelectorAll('[data-rw-topic]');
    var empty = root.querySelector('[data-rw-empty]');
    var topic = '';

    cards.forEach(function (c, i) { c.dataset.rwOrder = i; });

    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var shown = 0;
      cards.forEach(function (c) {
        var hay = (c.getAttribute('data-rw-text') || '').toLowerCase();
        var ok = (!q || hay.indexOf(q) > -1) && (!topic || hay.indexOf(topic) > -1);
        c.hidden = !ok;
        if (ok) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    }

    function order() {
      var mode = sort ? sort.value : 'listed';
      var arr = cards.slice();
      arr.sort(function (a, b) {
        var sa = parseFloat(a.getAttribute('data-rw-stars')) || 0;
        var sb = parseFloat(b.getAttribute('data-rw-stars')) || 0;
        if (mode === 'high' && sa !== sb) return sb - sa;
        if (mode === 'low' && sa !== sb) return sa - sb;
        return (a.dataset.rwOrder | 0) - (b.dataset.rwOrder | 0);
      });
      arr.forEach(function (c) { list.appendChild(c); });
    }

    if (search) search.addEventListener('input', apply);
    if (sort) sort.addEventListener('change', order);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var val = (chip.getAttribute('data-rw-topic') || '').toLowerCase();
        var same = topic === val;
        topic = same ? '' : val;
        chips.forEach(function (c) { c.classList.toggle('is-on', c === chip && !same); });
        apply();
      });
    });

    var more = root.querySelector('[data-rw-more]');
    if (more) {
      more.addEventListener('click', function () {
        root.classList.add('rw--all');
        more.remove();
      });
    }
  });
})();
